/**
 * Los contadores de arriba de Inventario (INV-01). No son tarjetas para mirar:
 * tocar "Agotados" deja la tabla de stock mostrando solo esos, y volver a
 * tocarlo lo quita. Es lo primero que se viene a ver al abrir inventario.
 *
 * El valorizado no filtra nada y por eso no es un boton: es el unico numero de
 * la fila que no se puede recorrer.
 */
import type { ResumenInventario } from '@bandu/compartido';

import { numero, pesos } from '../../utilidades/formato';
import type { EstadoStock } from '../../utilidades/filtros-inventario';

export interface ContadoresInventarioProps {
  resumen: ResumenInventario;
  /** El estado que hoy filtra la tabla, para marcar su contador. */
  activo: EstadoStock | null;
  onElegir(estado: EstadoStock | null): void;
}

export function ContadoresInventario({ resumen, activo, onElegir }: ContadoresInventarioProps) {
  const contadores: { estado: EstadoStock; texto: string; valor: number; tono: string }[] = [
    { estado: 'agotados', texto: 'Agotados', valor: resumen.agotados, tono: 'critico' },
    {
      estado: 'por_agotarse',
      texto: `Por agotarse (${numero(resumen.umbralPorAgotarse)} o menos)`,
      valor: resumen.porAgotarse,
      tono: 'alerta',
    },
    { estado: 'con_stock', texto: 'Con stock', valor: resumen.conStock, tono: 'ok' },
  ];

  return (
    <ul className="contadores-inventario" aria-label="Resumen del inventario">
      {contadores.map((contador) => {
        const elegido = activo === contador.estado;
        return (
          <li key={contador.estado}>
            <button
              type="button"
              className={`contador-inventario ${contador.tono}${elegido ? ' elegido' : ''}`}
              aria-pressed={elegido}
              onClick={() => {
                onElegir(elegido ? null : contador.estado);
              }}
            >
              <span className="contador-inventario-valor">{numero(contador.valor)}</span>
              <span className="contador-inventario-texto">{contador.texto}</span>
            </button>
          </li>
        );
      })}
      <li>
        <div className="contador-inventario valorizado">
          <span className="contador-inventario-valor">{pesos(resumen.valorizado)}</span>
          <span className="contador-inventario-texto">Valorizado a precio de venta</span>
        </div>
      </li>
    </ul>
  );
}
